import React from 'react'
import { Modal, ModalProps } from 'reactstrap'
import { getContainerProp } from '../../Webcomponent/utils/common'
import { useAppSelector } from '../../redux/hooks'

type ModalWrapperProps = ModalProps & {
  children: React.ReactNode
}

const ModalWrapper: React.FC<ModalWrapperProps> = ({ children, ...dialogProps }) => {
  const { modalContainer } = useAppSelector((state) => state.templateCustomizer)
  return (
    <Modal {...(getContainerProp(modalContainer) || {})} {...dialogProps}>
      {children}
    </Modal>
  )
}

export default ModalWrapper
